<template>
  <ViewLoader v-if="loading"/>

  <section class="checkout-section-wrapper" v-else>

    <CheckoutSuccess v-if="orderId" :order-id="orderId"/>

    <template v-else-if="hasCartItems">
      <ModalVoucher :checkinId="voucherCheckinId" @voucher-redeemed="$store.dispatch('cart/getCart')"/>
      <ViewHeader class="d-none d-lg-block">
        <template slot="title">{{ $t('pages.checkout.page_title') }}</template>
        <template slot="intro">{{ $t('pages.checkout.page_subtitle') }}</template>
      </ViewHeader>

      <div class="container view-body view-body--padded">
        <div class="row pb-lg-8">
          <template>
            <section class="col-lg-8">
              <CheckoutDigitalItems v-if="containsDigitalItems" :digital-items="getDigitalItems"
                                    @open-modal-voucher="openModalVoucher($event)"/>
            </section>

            <section class="col-lg-4 _sticky-wrapper--element">
              <header class="checkout-section__header d-none d-md-block">
                <h2 class="checkout-section__header__title">{{ $t('pages.checkout.summary_section_title') }}</h2>
              </header>

              <CheckoutSummary @pay-clicked="checkout($event)"/>

              <CheckoutStripeCard modalId="checkout-paywithcard"
                                  :total="getGrandTotalFormatted"
                                  v-on:order-success="orderId = $event"/>

              <CheckoutStripeIdeal modalId="checkout-paywithideal"
                                   :total="getGrandTotalFormatted"
                                   v-on:order-success="orderId = $event"/>

               <CheckoutStripeP24 modalId="checkout-paywithp24"
                                   :total="getGrandTotalFormatted"
                                   v-on:order-success="orderId = $event"/>


              <CheckoutMercadoPago modalId="checkout-paywithmercadopago"
                     :total="getGrandTotalFormatted" :payment-settings="paymentSettingsMercadoPago"
                     v-on:order-success="orderId = $event"/>

              <CheckoutPayWithBankTransfer modalId="checkout-paywithbanktransfer"
                                           :total="getGrandTotalFormatted"
                                           v-on:order-success="orderId = $event"
                                           ref="paywithbanktransfer"/>

              <PaymentWithCardInfos :payment-methods="getPaymentMethods"/>
            </section>

          </template>
        </div>
      </div>
    </template>


    <CheckoutEmptyCart v-else/>

  </section>
</template>


<script>
import {mapGetters} from 'vuex'
import {
  PAYMENT_METHOD_CARD,
  PAYMENT_METHOD_BANK_TRANSFER,
  PAYMENT_METHOD_IDEAL,
  PAYMENT_METHOD_MERCADO_PAGO,
    PAYMENT_METHOD_P24
} from "@/consts.js"

import ViewHeader from '@/components/ViewHeader'
import CheckoutEmptyCart from "@/components/CheckoutEmptyCart"
import CheckoutSummary from "@/components/CheckoutSummary"
import CheckoutDigitalItems from "@/components/CheckoutDigitalItems"
import CheckoutStripeCard from "@/components/CheckoutStripeCard"
import CheckoutPayWithBankTransfer from "@/components/CheckoutPayWithBankTransfer"
import PaymentWithCardInfos from "@/components/PaymentWithCardInfos"
import ViewLoader from "@/components/ViewLoader"
import ModalVoucher from "@/components/ModalVoucher"
import CheckoutSuccess from "@/views/CheckoutSuccess"
import CheckoutStripeIdeal from "@/components/CheckoutStripeIdeal";
import CheckoutMercadoPago from "@/components/CheckoutMercadoPago";
import CheckoutStripeP24 from "@/components/CheckoutStripeP24.vue";

export default {
  components: {
      CheckoutStripeP24,
    CheckoutMercadoPago,
    CheckoutStripeIdeal,
    ViewLoader,
    ViewHeader,
    ModalVoucher,
    CheckoutEmptyCart,
    CheckoutDigitalItems,
    CheckoutSummary,
    CheckoutStripeCard,
    CheckoutPayWithBankTransfer,
    CheckoutSuccess,
    PaymentWithCardInfos
  },

  data() {
    return {
      loading: true,
      isMobileOpen: false,
      orderId: null,
      voucherCheckinId: null,
    }
  },

  created() {

  },

  mounted() {
    /*
    Aggiorno il carrello e ne approfitto per sicronizzare i print item con quelli dell'ordine da Photosi
    Nota: la sincronizzazione con PhotoSì è stata disabilitata, per ripristinarla passare {sync_print_order: true}
    */
    let promiseCart = this.$store.dispatch('cart/getCart')
    // let promiseProducts = this.$store.dispatch('prints/getProducts')

    Promise.all([promiseCart])  // [promiseCart, promiseProducts]
        .then(arrayOfValuesOrErrors => {
          console.log('PROMISE ALL THEN arrayOfValuesOrErrors', arrayOfValuesOrErrors)
          const promiseResponse = arrayOfValuesOrErrors[0]
          if (promiseResponse.status === 500) {
            alert('Problem! Please try again later')
          }
          this.loading = false
          console.log('PROMISE ALL THEN', promiseResponse)
        })
        .catch(function (err) {
          console.log('PROMISE ALL ERR', err.message) // some coding error in handling happened
        })
  },

  computed: {
    ...mapGetters('cart', [
      'containsDigitalItems',
      'getDigitalItems',
      'getGrandTotalFormatted',
      'getPaymentSettings',
      'getPaymentMethods'
    ]),
    paymentSettingsMercadoPago() {
      return this.getPaymentSettings[PAYMENT_METHOD_MERCADO_PAGO]
    },
    hasCartItems() {
      return this.containsDigitalItems
    },
  },

  methods: {
    PAYMENT_METHOD_MERCADO_PAGO() {
      return PAYMENT_METHOD_MERCADO_PAGO
    },
    async checkout(paymentMethodSelected) {

      if (paymentMethodSelected === null) {
        this.loading = true
        this.$store.dispatch("cart/placeOrder", {paymentMethod: null})
            .then(response => {
              console.log('response', response)
              this.loading = false
              this.$store.dispatch('cart/teardownCart')
              this.orderId = response.data.id
            })
            .catch(function (error) {
              console.log('ZERO-AMOUNT ERROR', error)
            })
      } else if (paymentMethodSelected === PAYMENT_METHOD_CARD) {
        this.$bvModal.show('checkout-paywithcard')
      } else if (paymentMethodSelected === PAYMENT_METHOD_IDEAL) {
        this.$bvModal.show('checkout-paywithideal')
      } else if (paymentMethodSelected === PAYMENT_METHOD_MERCADO_PAGO) {
          this.$bvModal.show('checkout-paywithmercadopago')
      } else if (paymentMethodSelected === PAYMENT_METHOD_P24) {
          this.$bvModal.show('checkout-paywithp24')
      } else if (paymentMethodSelected === PAYMENT_METHOD_BANK_TRANSFER) {
        this.$refs.paywithbanktransfer.showAndPay()
      }
    },

    openModalVoucher(checkinId) {
      this.voucherCheckinId = checkinId
      this.$bvModal.show('modal-voucher')
      this.$store.dispatch('cart/getCart')
          .then(() => {
          })
    }
  }
}
</script>
